<template>
  <v-dialog v-model="dialog" width="500px">
    <v-form ref="form" v-model="form" lazy-validation v-if="item">
      <v-card>
        <v-card-title>
          <span class="headline">Discount</span>
        </v-card-title>
        <v-card-text v-if="!loading">
          <v-layout wrap>
            <v-flex xs12 md12>
              <v-select
                :items="items"
                v-model="model"
                label="List of discounts"
                item-text="resume"
                return-object
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>- Or -</v-flex>
            <v-flex xs12 md12>
              <v-text-field v-model="model.discountLabel" label="Label"></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-radio-group v-model="model.discountType" :column="false">
                <v-radio label="Percent" value="percent" class="mr-4"></v-radio>
                <v-radio label="Amount" value="amount"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field v-model="model.discountAmount" label="Value" type="number"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text v-else align-center justify-center column fill-height>
          <v-progress-circular :size="70" :width="7" indeterminate color="error"></v-progress-circular>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="update()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
    item: null,
    loading: false,
    form: null,
    dialog: false,
    model: {
      discountLabel: null,
      discountType: null,
      discountAmount: null
    },
    discounts:[]
  }),
  computed: {
    items () {
      return this.discounts.map(d => {
        d.resume = `${d.discountLabel} (${d.discountAmount}${d.discountType=='percent' ? '%' : '.-'})`
        return d
      })
    }
  },
  mounted () {
    this.loadDiscounts()
  },
  methods: {
    ...mapActions('orderRows', ['getDiscountList', 'updateDiscount', 'removeDiscount']),
    open(row) {
      this.item = row,
      this.dialog=true
    },
    loadDiscounts () {
      this.getDiscountList()
      .then(({discounts}) => this.discounts = discounts)
    },
    update: function() {
      this.loading = true;
      this.updateDiscount({
          discount: this.model,
          rowId: this.item.id
        })
        .then(result => {
          this.resetForm();
          this.dialog = false;
          this.$emit("updated", result);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetForm() {
      this.model.id = null;
      this.model.discountLabel = null;
      this.model.discountType = null;
      this.model.discountAmount = null;
      this.$refs.form.reset();
    }
  },
};
</script>

<style></style>
